import axios from "axios";

export const getBuyersRecent = async (userID: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Trip/recent-buyers?UserID=${userID}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
